export const ticketBetToRow = (tb, i) => ({
  key: tb.wager_set_ref ?? i,
  balls: tb.balls,
  outcomeTitle: tb.outcome?.outcome_title,
  marketTitle: tb.market_title,
  outcomeType: tb.outcome?.outcome_type,
  stake: tb.set_amount,
  odds: tb.outcome?.odds,
  status: tb.status,
});
